import axios from "axios";
import type { Application } from "@/types/jben/application.ts";
import type { QuickApplyProfile } from "@utils/jben/build_quick_apply_profile";

type Args = {
  application: Application;
  submitPath: string;
  fingerprint: string;
  jobApplicationRequestToken?: string;
  markAsDreamJob?: boolean;
  quickApply?: QuickApplyProfile | null;
};

export async function submitApplication({
  application,
  submitPath,
  fingerprint,
  jobApplicationRequestToken,
  markAsDreamJob,
  quickApply,
}: Args) {
  const body: Record<string, unknown> = {
    job_application: application,
    fingerprint,
  };

  if (jobApplicationRequestToken) {
    body["request_token"] = jobApplicationRequestToken;
  }

  if (markAsDreamJob) {
    body["mark_as_dream_job"] = true;
  }

  if (quickApply) {
    body["quick_apply"] = quickApply;
  }

  return axios.post(submitPath, body);
}
